<template>
<div class="tk036" v-cloak>
    <breadcrumb :navListCustom="[{title:'マイページ', routerName: tk010Init.myPage, param: {pageNo: '81'}}, {title:$t('tk001.labels.title'), routerName: tk010Init.teikiListPage, param: {pageNo: '88'}}, {title:'定期詳細', routerName: '', param: {}}]"></breadcrumb>
    <div>
        <div class="itemTitle">
            <h2>{{$t('common.labels.titleHeaderOrder')}}</h2>
        </div>
        <div class="pageFeed">
            <div class="subTitle">
                <h3>{{$t('tk010.labels.title')}}</h3>
            </div>
            <!--エラーメッセージ表示-->
            <div class="errorMessage">
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="TK036_PART"/>
            </div>
            <!-- お届先情報見出し -->
            <p class="teikiOrderYmd">
                <strong class="subTitle2">
                    {{$t('tk010.labels.titleSub1')}}{{reqModel.last_syukka_yotei_ymd}}{{$t('tk010.labels.titleSub2')}}
                </strong>
            </p>
            <p class="tdkchange">
                <!-- 届先変更 -->
                <input class="btnSubmit" type="button" @click="changeTdk()" :value="$t('tk010.labels.shiharaiChange')">
            </p>
            <p class="paychange" v-if="tk010Init.teikiPayChangeFlg == 1">
                <!-- 支払い方法変更 -->
                <input class="btnSubmit" type="button" @click="changeKessai()" :value="$t('tk001.buttons.shiharaiChange')">
            </p>
            <div class="tdkTitle">
                <strong class="webNm">
                    {{$t('tk010.labels.tdkInfo')}}
                </strong>
            </div>
            <!-- お届先情報内容 -->
            <div class="teikiTdkInfo" v-for="(item, itemIndex) in tk010Init.orderDetailsInfo" :key="itemIndex">
                <!-- 定期番号 -->
                <div class="tdk">
                    <div class="teikiTdkColumn">{{$t('tk010.labels.teikiNo')}}</div>
                    <div class="teikiTdkData"><span>{{item.TEIKI_CD_TYPICAL}}</span></div>
                </div>
                <!-- 配送先名 -->
                <div class="tdk">
                    <div class="teikiTdkColumn">{{$t('tk010.labels.deliName')}}</div>
                    <div class="teikiTdkData"><span>{{item.TDK_NM}}</span></div>
                </div>
                <!-- 配送先名カナ -->
                <div class="tdk">
                    <div class="teikiTdkColumn">{{$t('tk010.labels.kanaName')}}</div>
                    <div class="teikiTdkData"><span>{{item.TDK_KANA}}</span></div>
                </div>
                <!-- 配送先郵便番号 -->
                <div class="tdk">
                    <div class="teikiTdkColumn">{{$t('tk010.labels.postalCode')}}</div>
                    <div class="teikiTdkData"><span>{{item.TDK_ZIP}}</span></div>
                </div>
                <!-- 配送先住所 -->
                <div class="tdk">
                    <div class="teikiTdkColumn">{{$t('tk010.labels.shipAddress')}}</div>
                    <div class="teikiTdkData"><span>{{item.TDK_ADDR1}}{{item.TDK_ADDR2}}{{item.TDK_ADDR3}}</span></div>
                </div>
                <!-- 配送先電話番号 -->
                <div class="tdk">
                    <div class="teikiTdkColumn">{{$t('tk010.labels.phoneNumber')}}</div>
                    <div class="teikiTdkData"><span>{{item.TDK_TEL1}}</span></div>
                </div>
                <!-- 配達指定 -->
                <div class="tdk">
                    <div class="teikiTdkColumn">{{$t('tk010.labels.deliDes')}}</div>
                    <div class="teikiTdkData">
                        <p class="tdkYmd">
                            {{$t('tk010.labels.newDeliDate')}}{{item.TDK_YMD}}
                        </p>
                        <p class="tdkHstm">
                            {{$t('tk010.labels.timeZone')}}{{item.HSTM}}
                        </p>
                        <p class="tdkKankaku">
                            {{$t('tk010.labels.teikiKankaku')}}{{item.TEIKI_KANKAKU}}{{$t('tk010.labels.teikiKankakuKbn['+item.TEIKI_KANKAKU_KBN+']')}}
                        </p>
                    </div>
                </div>
                <!-- 配送業者 -->
                <div class="tdk" v-if="item.TRANS_CO_KBN_NM">
                    <div class="teikiTdkColumn">{{$t('tk010.labels.deliveryCompany')}}</div>
                    <div class="teikiTdkData"><span>{{item.TRANS_CO_KBN_NM}}</span></div>
                </div>
                <!-- 便種 -->
                <div class="tdk" v-if="item.BINSYU_KBN_NM">
                    <div class="teikiTdkColumn">{{$t('tk010.labels.binsyu')}}</div>
                    <div class="teikiTdkData"><span>{{item.BINSYU_KBN_NM}}</span></div>
                </div>
                <!-- ギフト指定 -->
                <div class="tdk">
                    <div class="teikiTdkColumn">{{$t('tk010.labels.giftDes')}}</div>
                    <div class="teikiTdkData">
                        <span>{{item.GIFT_NM == ' '? $t('tk010.labels.giftnothave') : item.GIFT_NM}}</span>
                    </div>
                </div>
                <!-- お支払方法 -->
                <div class="tdk">
                    <div class="teikiTdkColumn">{{$t('tk010.labels.shiharaiMethod')}}</div>
                    <div class="teikiTdkData"><span>{{item.KESSAI_NM}}</span></div>
                </div>
            </div>

            <div class="teikiItemInfo">
                <div class="teikiItemColumn" v-for="(item,index) in tk010Init.orderDetailsInfo" :key="index">
                    <!-- タイトルヘッダー -->
                    <div class="head">
                        <!-- 商品コード -->
                        <div class="teikiItemCd">{{$t('common.labels.productCode')}}</div>
                        <!-- 商品名 -->
                        <div class="ItemNm">{{$t('common.labels.productName')}}</div>
                        <!-- 単価 -->
                        <div class="unitPrice" v-if="tk010Init.tnkDspOption == 1">{{$t('common.labels.unitPrice')}}</div>
                        <!-- 数量 -->
                        <div class="qty">{{$t('tk010.labels.quanlity')}}</div>
                        <!-- 金額 -->
                        <div class="tax">{{$t('tk010.labels.kingakuStr')}}
                            <span class="price-tax">({{ item.TNK_DSP_KBN == '1'? $t('tk010.labels.taxInclude') : $t('tk010.labels.taxInclude1')}})</span>
                        </div>
                    </div>
                    <div class="teikiItemData" v-for="(teikiItem,teikiIndex) in tk010Init.orderProductsInfo" :key="teikiIndex">
                        <div class="body">
                            <!-- 商品コード -->
                            <div class="teikiItemCd" :aria-label="$t('common.labels.productCode')">
                                {{teikiItem.S_ITEM_CD}}
                            </div>
                            <!-- 商品名 -->
                            <div class="ItemNm" :aria-label="$t('common.labels.productName')">
                                {{teikiItem.ITEM_NM}}
                            </div>
                            <!-- 単価 -->
                            <div class="unitPrice" v-if="tk010Init.tnkDspOption == 1" :aria-label="$t('common.labels.unitPrice')">
                                {{ teikiItem.ZEI_SET_KBN == '1'? formatPrice(teikiItem.SALE_ZEI_K_TNK) : formatPrice(teikiItem.SALE_TNK)}}{{ $t('common.labels.jpYen') }}
                            </div>
                            <!-- 数量 -->
                            <div class="qty" :aria-label="$t('tk010.labels.quanlity')">
                                {{teikiItem.QTY}}
                            </div>
                            <!-- 金額 -->
                            <div class="tax" :aria-label="teikiItem.ZEI_SET_KBN == '1'? $t('tk010.labels.kingakuStrTax') : $t('tk010.labels.kingakuStrTax1')">
                                <span class="price">{{ teikiItem.ZEI_SET_KBN == '1'? formatPrice(teikiItem.ITEMSUM_TAX_IN) : formatPrice(teikiItem.ITEMSUM_TAX_EX)}}{{ $t('common.labels.jpYen') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="teikiTaxInfo" v-for="(item,detailsIndex) in tk010Init.orderDetailsInfo" :key="detailsIndex">
                <!-- 小計 -->
                <div>
                    <div class="teikiTaxColumn">{{$t('tk010.labels.subtotal')}}</div>
                    <div class="teikiTaxData">
                        <span class="price">
                            {{ item.TNK_DSP_KBN == '1'? formatPrice(item.ITEMSUM_TAX_IN) : formatPrice(item.ITEMSUM_TAX_EX)}}{{ $t('common.labels.jpYen') }}
                        </span>
                    </div>
                </div>
                <!-- 送料 -->
                <div v-if="item.SORYO_TAX_IN > '0' ">
                    <div class="teikiTaxColumn">{{item.SORYO_TITLE}}</div>
                    <div class="teikiTaxData">
                        <span class="price">
                            {{ item.TNK_DSP_KBN == '1'? formatPrice(item.SORYO_TAX_IN) : formatPrice(item.SORYO_TAX_EX)}}{{ $t('common.labels.jpYen') }}
                        </span>
                    </div>
                </div>
                <!-- 代引手数料 -->
                <div v-if="item.DAI_TESU_TAX_IN > '0' ">
                    <div class="teikiTaxColumn">{{item.DAI_TESU_TITLE}}</div>
                    <div class="teikiTaxData">
                        <span class="price">
                            {{ item.TNK_DSP_KBN == '1'? formatPrice(item.DAI_TESU_TAX_IN) : formatPrice(item.DAI_TESU_TAX_EX)}}{{ $t('common.labels.jpYen') }}
                        </span>
                    </div>
                </div>
                <!-- 払込手数料 -->
                <div v-if="item.PAY_TESU_TAX_IN > '0' ">
                    <div class="teikiTaxColumn">{{item.PAY_TESU_TITLE}}</div>
                    <div class="teikiTaxData">
                        <span class="price">
                            {{ item.TNK_DSP_KBN == '1'? formatPrice(item.PAY_TESU_TAX_IN) : formatPrice(item.PAY_TESU_TAX_EX)}}{{ $t('common.labels.jpYen') }}
                        </span>
                    </div>
                </div>
                <!-- 決済手数料-->
                <div v-if="item.KESSAI_TESU_TAX_IN > '0' ">
                    <div class="teikiTaxColumn">{{item.KESSAI_TESU_TITLE}}</div>
                    <div class="teikiTaxData">
                        <span class="price">
                            {{ item.TNK_DSP_KBN == '1'? formatPrice(item.KESSAI_TESU_TAX_IN) : formatPrice(item.KESSAI_TESU_TAX_EX)}}{{ $t('common.labels.jpYen') }}
                        </span>
                    </div>
                </div>
                <!-- 受取サービス手数料-->
                <div v-if="item.UKETORI_TESU_TAX_IN > '0' ">
                    <div class="teikiTaxColumn">{{item.UKETORI_TESU_TITLE}}</div>
                    <div class="teikiTaxData">
                        <span class="price">
                            {{ item.TNK_DSP_KBN == '1'? formatPrice(item.UKETORI_TESU_TAX_IN) : formatPrice(item.UKETORI_TESU_TAX_EX)}}{{ $t('common.labels.jpYen') }}
                        </span>
                    </div>
                </div>
                <!-- 包装料1-->
                <div v-if="item.WRAPPING1_TAX_IN > '0' ">
                    <div class="teikiTaxColumn">{{item.WRAPPING1_TITLE}}</div>
                    <div class="teikiTaxData">
                        <span class="price">
                            {{ item.TNK_DSP_KBN == '1'? formatPrice(item.WRAPPING1_TAX_IN) : formatPrice(item.WRAPPING1_TAX_EX)}}{{ $t('common.labels.jpYen') }}
                        </span>
                    </div>
                </div>
                <!-- 包装料2-->
                <div v-if="item.WRAPPING2_TAX_IN > '0' ">
                    <div class="teikiTaxColumn">{{item.item_wrapping2_title}}</div>
                    <div class="teikiTaxData">
                        <span class="price">
                            {{ item.TNK_DSP_KBN == '1'? formatPrice(item.WRAPPING2_TAX_IN) : formatPrice(item.WRAPPING2_TAX_EX)}}{{ $t('common.labels.jpYen') }}
                        </span>
                    </div>
                </div>
                <!-- 消費税 -->
                <div v-if="item.SEIKYUU_TAX > '0' ">
                    <div class="teikiTaxColumn">{{$t('tk010.labels.consumptionTax')}}</div>
                    <div class="teikiTaxData">
                        <span class="price">
                            {{ formatPrice(item.SEIKYUU_TAX)}}{{ $t('common.labels.jpYen') }}
                        </span>
                    </div>
                </div>
                <!-- お支払い金額 -->
                <div>
                    <div class="teikiTaxColumn">{{$t('tk010.labels.paymentMoney')}}</div>
                    <div class="teikiTaxData">
                        <span class="price">
                            {{ formatPrice(item.SEIKYUU_TAX_IN)}}{{ $t('common.labels.jpYen') }}
                        </span>
                    </div>
                </div>
            </div>
            <table class="table th">
            <thead>
                <tr>
                    <!--回数-->
                    <th class="">{{$t('sh060.labels.numberOfTime')}}</th>
                    <!--出荷予定日-->
                    <th class="">{{$t('pt460.labels.syukkaYoteiYmd')}}</th>
                    <!--お届け希望日-->
                    <th class="">{{$t('pt460.labels.deliDates')}}</th>
                    <!--希望時間帯-->
                    <th class="">{{$t('希望時間帯')}}</th>
                    <!--スキップ-->
                    <th class="">{{$t('スキップ')}}</th>
                    <!--お届希望日変更-->
                    <th class="">{{$t('お届希望日変更')}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in tk010Init.orderYoteiInfo" :key="index">
                    <!--回数-->
                    <td>
                    <span v-if="item.TEIKI_MAKE_KAISU != '-1'">{{item.TEIKI_MAKE_KAISU}}{{$t('回目')}}</span>
                    <span v-else>{{$t('-')}}</span>
                    </td>
                    <!--出荷予定日-->
                    <td>{{item.SYUKKA_YOTEI_YMD}}</td>
                    <!--お届け希望日-->
                    <td>{{item.TDK_YMD}}</td>
                    <!--希望時間帯-->
                    <td>{{item.HSTM}}</td>
                    <!--スキップ-->
                    <td>
                        <!--スキップ中(解除不可)-->
                        <input  type="button" v-if="item.SKIP_FLG == '1' && item.TEIKI_YOTEI_NO == tk010Init.nextOrder" @click="denySkip()" :value="$t('tk001.buttons.skipNow')"> 
                        <!--スキップ中-->
                        <input  type="button" v-else-if="item.SKIP_FLG == '1'" @click="cancelSkip(item.TEIKI_NO,item.TEIKI_YOTEI_NO)" :value="$t('tk001.buttons.skipNow')">
                        <!--スキップ-->
                        <input  type="button" v-else class="btnSubmit" @click="changeToSkip(item.TEIKI_NO,item.TEIKI_YOTEI_NO,item.TEIKI_MAKE_KAISU)" :value="$t('スキップ')">
                    </td>
                    <!--お届希望日変更-->
                    <td><button type="button" @click="changeTdkDay(item.TEIKI_NO,item.TEIKI_YOTEI_NO,item.TDK_YMD,item.SYUKKA_YOTEI_YMD,item.HSTM_KBN,item.TEIKI_CD_TYPICAL)">{{$t('common.buttons.DeliButton')}}</button></td>
                </tr>
            </tbody>
        </table>
            <ul class="button-column">
                <!-- 前のページへ戻る -->
                <li><input class="btnCancel" type="submit" name="submitButtonName" @click="backStep()" onkeypress="backStep()" :value="$t('common.labels.backButton')"></li>
            </ul>
        </div>

    </div>
    <TK012 v-if="showTk020Flg" @data-selected="setDataTk020"></TK012>
    <TK037 v-if="showTk013Flg" :data="dataTk013" @data-selected="setDataTk013"></TK037>
</div>  
</template>

<script>

import $ from 'jquery';
import axios from "assets/js/request";
import common from "assets/js/common";
import DataTable from 'components/Datatable';
import InputCheck from 'components/InputCheck';
import Message from 'components/MessageEcSite';
import DownloadFile from 'components/DownloadFile';
import DatePickers from 'components/DatePicker';
import InputNumber from "components/InputNumber";
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import TK012 from '../popup/TK012MemberTdkDetails.vue';
import TK037 from '../popup/TK037MemberTeikiIkkatuTdkList.vue';
import EventBus from 'assets/js/eventBus';

export default {
    /* 
    * Name of component
    */
    name: "TK036TeikiIkkatuDetailParts",
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /* 
    * Declare components
    */
    components: {
        DataTable,
        Message,
        DatePickers,
        InputCheck,
        DownloadFile,
        InputNumber,
        TK012,
        TK037,
        Breadcrumb
    },
    /* 
    * Declare variable and set default value
    */
    data: function() {
        return {
            orderDetailsInfo:[],
            orderProductsInfo:[],
            orderHeadInfo:{},
            orderTotInfo:{},
            reqModel:{
                fBaFLG:null,
                orderCdTypical:null,
                updateFlg: "0"
            },
            tk010reqModel:{
                orderNo:null
            },
            siteFlg: null,
            requestBack:{},
            SiteConstants:SiteConstants,
            soryoKin: null,
            uketoriKin: null,
            usePoint: null,
            linkJP: null,
            linkSG: null,
            linkYA: null,
            //TK020
            showTk020Flg: false,
            showTk013Flg:false,
            dataTk013:{},
            isDisabled: false,
            site: "",
            tk010Init:{},
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            TK036_PART: 'tk036'
        }
    },
    /* 
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        //Call API doInit
        if (_this.ptInitData){
            if(_this.ptInitData.status == 'NG'){
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
            } else {
                _this.tk010Init = _this.ptInitData;
                _this.reqModel.last_syukka_yotei_ymd = _this.tk010Init.orderDetailsInfo[0].LAST_SYUKKA_YOTEI_YMD;
                _this.reqModel = Object.assign({}, _this.reqModel, _this.ptInitData.reqModel);
            }
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.TK036 + _this.$UrlConstants.DO_INIT, _this.reqModel).then(function(response) {
                if(response.data.status == 'NG'){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
                } else {
                    _this.tk010Init = response.data;
                    _this.reqModel.last_syukka_yotei_ymd = _this.tk010Init.orderDetailsInfo[0].LAST_SYUKKA_YOTEI_YMD;
                    _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModel);
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    /* 
    * Methods
    */
    methods: { 

        /* 
        * Function order 
        */
        changeTdk: function(){
            this.showTk020Flg = true;
        },
        changeTdkDay: function(teikiNo,yoteiNo,tdkYmd,SyukkaYmd,tdkTimeKbn,teikiCdTypical){
            var _this = this;
            _this.showTk013Flg = true;
            _this.reqModel.teikiNo = teikiNo;
            _this.reqModel.yoteiNo = yoteiNo;
            _this.reqModel.tdkYmd = common.stringNvl(tdkYmd,SyukkaYmd);
            _this.reqModel.tdkTimeKbn = tdkTimeKbn;
            _this.dataTk013.teikiNo = teikiNo;
            _this.dataTk013.teikiCdTypical = teikiCdTypical;
            _this.dataTk013.yoteiNo = yoteiNo;
            _this.dataTk013.tdkYmd = common.stringNvl(tdkYmd,SyukkaYmd);
            _this.dataTk013.tdkTimeKbn = tdkTimeKbn;
        },
        denySkip: function(){
            var _this = this;
            var rs;
            rs = confirm(_this.$i18n.t('tk001.labels.confirmMess3'));
        },
        changeToSkip: function(teikiNo,yoteiNo,teikiMakeKaisu){
            var _this = this;
            var rs;
            _this.reqModel.teikiNo = teikiNo;
            _this.reqModel.yoteiNo = yoteiNo;
            _this.reqModel.teikiMakeKaisu = teikiMakeKaisu;
            _this.reqModel.updateFlg = '1';
            rs = confirm(_this.reqModel.teikiMakeKaisu + _this.$i18n.t('tk001.labels.confirmMess'));
            if(rs){
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.TK036 + _this.$UrlConstants.DO_UPDATE, _this.reqModel).then(function(response) {
                if(response.data.status == 'NG'){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
                } else {
                    _this.tk010Init = response.data;
                    _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModel);
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
            }else{
                return false;
            }
        },
        cancelSkip: function(teikiNo,yoteiNo){
            var _this = this;
            var rs;
            _this.reqModel.teikiNo = teikiNo;
            _this.reqModel.yoteiNo = yoteiNo;
            _this.reqModel.updateFlg = '2';
            rs = confirm(this.$i18n.t('tk001.labels.confirmMess4'));
            if(rs){
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.TK036 + _this.$UrlConstants.DO_UPDATE, _this.reqModel).then(function(response) {
                if(response.data.status == 'NG'){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
                } else {
                    _this.tk010Init = response.data;
                    _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModel);
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
            }else{
                return false;
            }
        },
        setDataTk020: function(responseData){
            this.listMessValid = [];
            this.mapMessValid = [];
            common.clearMessageEcSite(this.listIdErr, this.TK036_PART);
            if(!responseData) {
                this.showTk020Flg = false;
                return;
            }
            var _this = this;
            _this.reqModel.tdk_cd = responseData.TDK_CD;
            _this.reqModel.tdk_no = responseData.TDK_NO;
            _this.reqModel.updateFlg = '0';
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.TK036 + _this.$UrlConstants.DO_UPDATE, _this.reqModel).then(function(response) {
                if(response.data.status == 'NG'){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
                } else {
                    _this.tk010Init = response.data;
                    _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModel);
                }
            }).catch(function(error) {
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.TK036_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
            _this.showTk020Flg = false;
        },
        setDataTk013: function(responseData){
            if(!responseData) {
                this.showTk013Flg = false;
                this.$router.go(0);
                return;
            }
        },
        //function back
        backStep: function(){
            var _this = this;
            const parameter = _this.generateLinkParams(88,_this.tk010Init.teikiListPage);
            _this.$router.push(parameter);
        },
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /*
        * 決済方法変更
        */
        changeKessai: function() {
            var _this = this;
            var teikiFlg = '1';
            var teikiNo = _this.reqModel.teikiNo;
            var teikiCdTypical = _this.reqModel.teikiCdTypical;
            const parameter = _this.generateLinkParams(82,_this.tk010Init.payChangePage,{},{teikiFlg:teikiFlg,teikiNo:teikiNo,backPageNo:89,teikiCdTypical:teikiCdTypical});
            _this.$router.push(parameter);
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        },
    },
    
    /*
    * Excute code after an instance is created
    */
    created: function(){
        var _this = this;
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.ptPageNo != null){
                this.reqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.reqModel.pageSize = this.queryData.ptPageSize;
            }
        }

        // Get data from params and query
        var paramData = _this.$route.params;
        if(Object.keys(paramData).length > 0){
            _this.reqModel.teikiNo = paramData.teiki_no;
        }
    },
}
</script>
